import {useEffect, useState} from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import './DateRangeSelector.global.scss';
import styles from './DateRangeSelector.module.scss'
import * as moment from 'moment-timezone';
import {FaCalendar} from 'react-icons/fa';

const DateRangeSelector = ({
                               startDate,
                               endDate,
                               onChange,
                               greyStyle,
                               fullWidth
                           }) => {
    moment.tz.setDefault('Etc/UTC');
    const ranges = {
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'This Year': [moment().startOf('year'), moment().endOf('year')],
        'Last Year': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
    };

    const [range, setRange] = useState(startDate || endDate ? 'Custom Range' : 'Last 30 Days');
    const [startDateValue, setStartDateValue] = useState(startDate ? moment(startDate).utc() : moment().utc().subtract(29, 'days'));
    const [endDateValue, setEndDateValue] = useState(endDate ? moment(endDate).utc() : moment().utc());
    const [show, setShow] = useState(false);

    useEffect(() => {
        const getRange = Object.keys(ranges).filter(key => ranges[key][0].isSame(startDateValue, 'day') && ranges[key][1].isSame(endDateValue, 'day'));
        setRange(getRange.length ? getRange[0] : 'Custom Range');

    }, [startDateValue, endDateValue])

    return (
        <div style={{
            position: 'relative',
        }}>
            <div className={`${styles.dateRangePicker} ${show && styles.isOpen}`}>
                <DateRangePicker
                    initialSettings={{
                        startDate: startDateValue.format('MM/DD/YYYY'),
                        endDate: endDateValue.format('MM/DD/YYYY'),
                        ranges: ranges,
                        showCustomRangeLabel: true,
                        alwaysShowCalendars: true,
                        opens: 'left',
                        showTimezone: true,
                        parentEl: '#content',
                    }}
                    onEvent={(event, picker) => {
                        if (event.type === 'apply') {
                            setStartDateValue(picker.startDate.utc())
                            setEndDateValue(picker.endDate.utc())
                            if (onChange) {
                                onChange({
                                    startDate: picker.startDate.utc().format('YYYY/MM/DD'),
                                    endDate: picker.endDate.utc().format('YYYY/MM/DD')
                                })
                            }
                        } else if (event.type === 'show') {
                            setShow(true)
                        } else if (event.type === 'hide') {
                            setShow(false)
                        }
                    }}
                >
                    <button className={`${styles.btn} ${greyStyle && styles.btnGrey} ${fullWidth && styles.fullWidthBtn}`}>
                        <span className={styles.dateRangeLabel}>{range && `${range}: `}</span>
                        <span
                            className={styles.date}>{startDateValue.format('DD/MM/YYYY')} - {endDateValue.format('DD/MM/YYYY')}</span>
                        {fullWidth && <FaCalendar/>}
                    </button>
                </DateRangePicker>
            </div>
        </div>
    );
}

export default DateRangeSelector;